module.exports = __webpack_public_path__ + "img/ii-sjjc.25e93d45.png";